import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "app/api";

export interface pagination {
    page: number;
    perPage: number;
}

export interface ListProduk {
    id: number;
    idCakupanProduk: string;
    uraianProduk: string;
    kbli: string;
    idProyek: string;
    idProduk: string;
    idPengajuanSertifikatHalalDetail: string;
}

export interface ProdukHalal {
    id: number;
    idPengajuanSertifikatHalal: string;
    uraianJenisProduk: string;
    kodeKlasifikasiProduk: string;
    flagSelfDeclare: string;
    listProduk: ListProduk[];
}

export interface DataNIBChecklist {
    id: number;
    idProduk: string;
    idProyek: string;
    idIzin: string;
    jenisIzin: string;
    kdIzin: string;
    kdDaerah: string;
    namaIzin: string;
    instansi: string;
    parameterKewenangan: string;
    kewenangan: string;
    flagChecklist: string;
    flagTransaksional: string;
    flagPerpanjangan: string;
    noIzin: string;
    tglIzin: string;
    fileIzin: string;
    dataProdukHalal: ProdukHalal;
}

export interface DataNIBChecklistRequest {
    pagination: pagination
    filter: {
        id_izin: string | null;
        kd_izin: string | null;
    }
}

export interface DataNIBChecklistResponse {
    GETS_DATANIBCHECKLIST: {
        status: number,
        totalData: number,
        totalPage: number,
        currentPage: number,
        data: DataNIBChecklist[],
    }
}

export const getsDataNIBChecklist = createAsyncThunk(
    "getsDataNIBChecklist",
    async (data: DataNIBChecklistRequest, thunkAPI) => {
        const config = {
            method: "get",
            url: "pelaku-usaha/data-nib-checklist",
            params: data
        };

        return api(config).then(
            (res: any) => {
                return res.data;
            },
            (err: any) => {
                return thunkAPI.rejectWithValue(err.response.data.message);
            }
        );
    }
);

const DataNIBChecklistSlice = createSlice({
    name: "DataNIBChecklistSlice",
    initialState: {
        data: {
            GETS_DATANIBCHECKLIST: {
                status: 0,
                totalData: 0,
                totalPage: 0,
                currentPage: 0,
                data: [
                    {
                        id: 0,
                        idProduk: "",
                        idProyek: "",
                        idIzin: "",
                        jenisIzin: "",
                        kdIzin: "",
                        kdDaerah: "",
                        namaIzin: "",
                        instansi: "",
                        parameterKewenangan: "",
                        kewenangan: "",
                        flagChecklist: "",
                        flagTransaksional: "",
                        flagPerpanjangan: "",
                        noIzin: "",
                        tglIzin: "",
                        fileIzin: "",
                        dataProdukHalal: {
                            id: 0,
                            idPengajuanSertifikatHalal: "",
                            uraianJenisProduk: "",
                            kodeKlasifikasiProduk: "",
                            flagSelfDeclare: "",
                            listProduk: [
                                {
                                    id: 0,
                                    idCakupanProduk: "",
                                    uraianProduk: "",
                                    kbli: "",
                                    idProyek: "",
                                    idProduk: "",
                                    idPengajuanSertifikatHalalDetail: "",
                                }
                            ]
                        }

                    }
                ],
            },
        } as DataNIBChecklistResponse,
        isFetching: false,
        isSuccess: false,
        isError: false,
        isAuth: false,
        errorMessage: "" as string,
    },
    reducers: {
        clearState: (state, action) => {
            state.isFetching = false;
            state.isSuccess = false;
            state.isError = false;
            state.errorMessage = "";
        },
    },
    extraReducers: (builder) => {

        // getsDataNIBChecklist
        builder.addCase(getsDataNIBChecklist.fulfilled, (state, { payload }) => {
            state.isFetching = false;
            state.isSuccess = true;
            state.data = payload;
            return state;
        });
        builder.addCase(getsDataNIBChecklist.rejected, (state, payload: any) => {
            state.isFetching = false;
            state.isError = true;
            state.errorMessage = payload.payload;
        });
        builder.addCase(getsDataNIBChecklist.pending, (state, action) => {
            state.isFetching = true;
        });

    },
});

export const { clearState } = DataNIBChecklistSlice.actions;
export default DataNIBChecklistSlice.reducer;
